<script>
import { layoutMethods, layoutComputed } from '@/state/helpers'
import MetisMenu from 'metismenujs/dist/metismenujs'

import { SimpleBar } from 'simplebar-vue3'

/**
 * Sidebar component
 */
export default {
  mounted() {
    this.initializeMetisMenu()
    this.updateSidebar()
  },
  components: {
    SimpleBar,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...layoutComputed,
    mode: {
      get() {
        return this.$store ? this.$store.state.layout.layoutMode : {} || {}
      },
      set(value) {
        if (value === 'dark') {
          document.body.setAttribute('data-layout-mode', 'dark')
          this.changeLayoutMode({
            layoutMode: 'dark',
          })
          this.changeTopbar({
            topbar: 'dark',
          })
          this.changeSidebarColor({
            sidebarColor: 'dark',
          })
        } else {
          document.body.setAttribute('data-layout-mode', 'light')
          this.changeLayoutMode({
            layoutMode: 'light',
          })
          this.changeTopbar({
            topbar: 'light',
          })
          this.changeSidebarColor({
            sidebarColor: 'light',
          })
        }
      },
    },
  },
  data() {
    return {}
  },
  watch: {
    $route: {
      handler: 'updateSidebar',
      immediate: true,
      deep: true,
    },
    color: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'light':
              document.body.setAttribute('data-sidebar', 'light')
              break
            case 'dark':
              document.body.setAttribute('data-sidebar', 'dark')
              break
            case 'brand':
              document.body.setAttribute('data-sidebar', 'brand')
              break
            default:
              document.body.setAttribute('data-sidebar', 'dark')
              break
          }
        }
      },
    },
  },
  methods: {
    ...layoutMethods,
    initializeMetisMenu() {
      new MetisMenu('#side-menu')
    },
    updateSidebar() {
      this.$nextTick(() => {
        let links = document.getElementsByClassName('side-nav-link-ref')
        let matchingMenuItem = null
        const paths = []

        for (let i = 0; i < links.length; i++) {
          paths.push(links[i]['pathname'])
        }

        let currentPath = window.location.pathname
        let itemIndex = paths.indexOf(currentPath)
        if (itemIndex === -1) {
          for (let i = 0; i < paths.length; i++) {
            if (currentPath.includes(paths[i]) && paths[i] !== '/') {
              matchingMenuItem = links[i]
              break
            }
          }
        } else {
          matchingMenuItem = links[itemIndex]
        }

        // Remove old active classes
        document.querySelectorAll('.mm-active, .mm-show').forEach((el) => el.classList.remove('mm-active', 'mm-show'))

        // If a matching menu item is found, activate it and its parents
        if (matchingMenuItem) {
          matchingMenuItem.classList.add('active')
          this.activateParents(matchingMenuItem)
        }
      })
    },
    activateParents(element) {
      let parent = element.closest('li')

      while (parent && parent.id !== 'side-menu') {
        parent.classList.add('mm-active')

        let parentUl = parent.closest('ul')
        if (parentUl && parentUl.id !== 'side-menu') {
          parentUl.classList.add('mm-show')
        }

        let toggleElement = parent.querySelector('.has-arrow, .has-dropdown')
        if (toggleElement) {
          toggleElement.classList.add('mm-active')
        }

        parent = parent.parentElement.closest('li')
      }
    },
    toggleMenu() {
      this.$parent.toggleMenu()
    },
  },
}
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="vertical-menu">
    <!-- LOGO -->
    <div class="navbar-brand-box">
      <router-link to="/" class="logo logo-dark">
        <!-- <span class="logo-sm">
          <img src="@/assets/images/eze_nms_logo.svg" alt="" height="22" />
        </span> -->
        <span class="hamburger-icon cursor-pointer logo-sm sidemenu-toggle" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </span>
        <span class="logo-lg">
          <img src="@/assets/images/eze_nms_logo.svg" alt="" height="22" />
        </span>
      </router-link>

      <router-link to="/" class="logo logo-light">
        <span class="logo-lg">
          <img src="@/assets/images/eze_nms_logo.svg" alt="" height="22" />
        </span>
        <!-- <span class="logo-sm">
          <img src="@/assets/images/eze_nms_logo.svg" alt="" height="22" />
        </span> -->
        <span class="hamburger-icon cursor-pointer logo-sm sidemenu-toggle" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </router-link>
    </div>

    <button type="button" class="btn btn-sm px-3 header-item vertical-menu-btn topnav-hamburger" @click="toggleMenu">
      <span class="hamburger-icon">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>

    <SimpleBar data-simplebar class="sidebar-menu-scroll" ref="isSimplebar">
      <!--- Sidemenu -->
      <div id="sidebar-menu">
        <!-- Left Menu Start -->
        <ul class="metismenu list-unstyled" id="side-menu">
          <li class="menu-title" data-key="t-layout-mode">Theme</li>
          <li class="menu-check-options">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="mode" id="layout-mode-light" value="light" v-model="mode" />
              <label class="form-check-label" for="layout-mode-light">Light</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="mode" id="layout-mode-dark" value="dark" v-model="mode" />
              <label class="form-check-label" for="layout-mode-dark">Dark</label>
            </div>
          </li>
          <li class="menu-title" data-key="t-menu">Menu</li>
          <li v-if="authUserHasPermission('dashboard')">
            <router-link class="side-nav-link-ref" to="/">
              <eva-icon class="icon nav-icon" name="home-outline"></eva-icon>
              <span class="menu-item" data-key="t-home">Home</span>
            </router-link>
          </li>
          <li v-if="authUserHasPermission('dashboard')">
            <router-link class="side-nav-link-ref" to="/device-dashboard">
              <eva-icon class="icon nav-icon" name="cube-outline"></eva-icon>
              <span class="menu-item" data-key="t-cube">Device Dashboard</span>
            </router-link>
          </li>
          <li v-if="authUserHasPermission('alerts')" class="menu-title" data-key="t-alerts">Alerts</li>
          <li v-if="authUserHasPermission('pending_alerts_view')">
            <router-link class="side-nav-link-ref" to="/alerts/pending">
              <eva-icon class="icon nav-icon" name="alert-triangle-outline"></eva-icon>
              <span class="menu-item" data-key="t-pending-alerts">Pending Alerts</span>
            </router-link>
          </li>
          <li v-if="authUserHasPermission('cleared_alerts_view')">
            <router-link class="side-nav-link-ref" to="/alerts/cleared">
              <eva-icon class="icon nav-icon" name="checkmark-circle-outline"></eva-icon>
              <span class="menu-item" data-key="t-cleared-alerts">Cleared Alerts</span>
            </router-link>
          </li>
          <li v-if="authUserHasPermission('history_alerts_view')">
            <router-link class="side-nav-link-ref" to="/alerts/history">
              <eva-icon class="icon nav-icon" name="clock-outline"></eva-icon>
              <span class="menu-item" data-key="t-alerts-history">Alert History</span>
            </router-link>
          </li>
          <li v-if="authUserHasPermission('devices') || authUserHasPermission('device_credentials') || authUserHasPermission('device_category')" class="menu-title" data-key="t-device-management">
            Device Management
          </li>
          <li v-if="authUserHasPermission('devices')">
            <router-link class="side-nav-link-ref" to="/devices">
              <eva-icon class="icon nav-icon" name="monitor-outline"></eva-icon>
              <span class="menu-item" data-key="t-devices">Devices</span>
            </router-link>
          </li>
          <li v-if="authUserHasPermission('device_category')">
            <router-link class="side-nav-link-ref" to="/categories">
              <eva-icon class="icon nav-icon" name="list-outline"></eva-icon>
              <span class="menu-item" data-key="t-categories">Categories</span>
            </router-link>
          </li>
          <li v-if="authUserHasPermission('device_type_view')">
            <router-link class="side-nav-link-ref" to="/device/types">
              <eva-icon class="icon nav-icon" name="cube-outline"></eva-icon>
              <span class="menu-item" data-key="t-device-types">Device Types</span>
            </router-link>
          </li>
          <li v-if="authUserHasPermission('device_credentials')">
            <router-link class="side-nav-link-ref" to="/credentials">
              <eva-icon class="icon nav-icon" name="edit-outline"></eva-icon>
              <span class="menu-item" data-key="t-credentials">Credentials</span>
            </router-link>
          </li>
          <li class="menu-title" data-key="t-administration" v-if="authUserHasPermission('system_admin')">Administration</li>
          <li v-if="authUserHasPermission('system_admin')">
            <a href="javascript: void(0);" class="has-arrow">
              <eva-icon class="icon nav-icon" name="people-outline"></eva-icon>
              <span class="menu-item" data-key="t-authentication">Authentication</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
              <li v-if="authUserHasPermission('system_admin_accounts')">
                <router-link class="side-nav-link-ref" to="/users" data-key="t-users">Users</router-link>
              </li>
              <li v-if="authUserHasPermission('system_admin_roles')">
                <router-link class="side-nav-link-ref" to="/roles" data-key="t-roles">Roles</router-link>
              </li>
            </ul>
          </li>
          <li v-if="authUserHasPermission('alert_rules')">
            <a href="javascript: void(0);" class="has-arrow">
              <eva-icon class="icon nav-icon" name="bell-outline"></eva-icon>
              <span class="menu-item" data-key="t-alert-notifications">Alert Notifications</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
              <li v-if="authUserHasPermission('alert_rules')">
                <router-link class="side-nav-link-ref" to="/alert/rules" data-key="t-alert-rules">Rules</router-link>
              </li>
            </ul>
          </li>
          <li v-if="authUserHasPermission('system_admin')">
            <a href="javascript: void(0);" class="has-arrow">
              <eva-icon class="icon nav-icon" name="settings-outline"></eva-icon>
              <span class="menu-item" data-key="t-system-config">System Configuration</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
              <li v-if="authUserHasPermission('device_maintenance')">
                <router-link class="side-nav-link-ref" to="/maintenance/schedules" data-key="t-scheduled-maintenance">Maintenance</router-link>
              </li>
              <li v-if="authUserHasPermission('alert_threshold')">
                <router-link class="side-nav-link-ref" to="/alerts/threshold/11" data-key="t-threshold">Alerts Threshold</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <!-- Sidebar -->
    </SimpleBar>
  </div>
  <!-- Left Sidebar End -->
</template>
